import { Button, TextField } from "@mui/material";
import { useState } from "react";
import Popup from "reactjs-popup";
import './PopUp.css';

const PopUp = (props) => {
    const {message, success, resetInputs, handleRest, handleRestConfirm, warning} = props;
    const styleClass = success ? 'success' : warning ? 'warning' : 'error';
    const [open, setOpen] = useState(true);

    const close = () =>{
        resetInputs();
        setOpen(false);
    }

    const render = () => {
        if (handleRest !== undefined && handleRest !== null) {
            return (
                <div className={styleClass}>
                    <TextField 
                        label='Rest Quantity' 
                        type='number' 
                        onChange={(e) => handleRest(e.target.value)} 
                        InputLabelProps={{
                            shrink: true
                        }}
                        required
                    />
                    <Button onClick={() => handleRestConfirm()} >Confirm</Button>
                </div>
            )
        } else {
            return (
                <div className={styleClass}>
                    <p>{message}</p>
                    <button className='pop-btn' onClick={() =>close()}>Close</button>
                </div>
            )
        }
    }

    return (
        <Popup open={open} position='center center' >
            {render()}
        </Popup>
    )
};

export default PopUp;